export default __webpack_public_path__ + "static/media/hht2_ep8_speaking_02.06fb7202.png";